<template>
	<b-modal ref="profile_modal" size="xl" bodyClass="p-0"
	         v-bind:no-close-on-backdrop=true
	         :hide-header=true
	         v-model="is_show_modal"
	         :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2><span class="fw-300">Акт</span></h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="p-1" v-if="!is_load">
				<div class="user_equipments">
					<div class="user_equipment" v-for="user in users">

						<div class="row lst p-3">
							<div class="user_id col-1">
								{{user.user_id}}
							</div>
							<div class="user_fio col-10">
								{{user.name}}
							</div>
							<div class="user_adv col-1">
								<i class="fa fa-file-pdf make_pdf fs-xl color-primary-100 cursor-pointer"
								   v-on:click="make_pdf(user)"
								   aria-hidden="true"
								></i>
							</div>
						</div>

						<div class="user_items p-3" v-if="user.hasOwnProperty('equipments')">
							<div class="user_eq row" v-for="equipment in user.equipments" >
								<div class="inp col-1">
									<b-checkbox v-model="equipment.is_selected"></b-checkbox>
								</div>
								<div class="name col-9">
                                    <span v-if="equipment.hasOwnProperty('equipment_type')">
                                        {{equipment.equipment_type.title}}
                                    </span>
									<small>
										{{equipment.description}}
									</small>
								</div>
								<div class="cost col-2">
									{{equipment.price}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<template v-slot:modal-footer="{close}">
			<div class="modal-footer w-100">
				<button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed ml-5">
					Закрити
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import Users_select from "../../shared/select/users_select.vue";
import Organization_select from "../../shared/select/organization_select.vue";
import users_admin_select from "../../shared/select/users_admin_select.vue";
import Equipment_type_select from "../../shared/select/equipment_type_select.vue";

export default {
	name: "equipment_act",
	props: {
		activeFilters: {
			type: Object,
			required: false,
			default: {},
		},
		search: {
			type: String,
			default: '',
		},
	},
	components: {Equipment_type_select, users_admin_select, Organization_select, Users_select},
	created() {
		EventBus.$on("generate_act", this.show_user_choice);
		EventBus.$on('generate_excel',this.make_excel)
		EventBus.$on('selected_users', e => {
			if (e.uniq === this.uniq_u) {
				EventBus.$emit('close_u_filter');
				this.load_users(e.users);
			}
		});

		EventBus.$on(this.remove_fire_from_doc, e => {
			this.clean_user();
		});
	},

	data() {
		return {
			uniq_u: 'act_user_add',
			users: [],
			remove_fire_from_doc: 'remove_fire',

			modal_position: "left",
			is_show_modal: false,
			is_load: false,

			form: {
				user_id: 0,
			}
		}
	},
	methods : {


		make_excel() {
			IMC_CORE.showloading();

			const filters = {
				...this.activeFilters,
				search: this.search
			}

			console.log(filters)

			api.post("/equipment/helper/excel", filters).then(({data}) => {
				IMC_CORE.hideloading();
				if(data.status == "operation_success") {
					let url = data.data;
					window.open(url, '_blank');
				}
			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
			});

		},

		show_user_choice () {
			EventBus.$emit('load_users_filter', {
					uniq: this.uniq_u,
					active: [],
				}
			);
		},

		async make_pdf(cur_user) {
			console.log('make_pdf',cur_user);
			let url = '/internal/equipment.generatePdf?user=' + cur_user.user_id;
			let users_equipments = "";
			let count = 0;

			if(cur_user.hasOwnProperty('equipments')) {
				cur_user.equipments.map(equipment => {
					if (equipment.is_selected) {
						users_equipments += "&selected_items[" + count + "]=" + equipment.id;
						count++;
					}
				});
			}
			url += users_equipments;

			let  win = window.open("https://office.imcagro.com.ua/" + url, '_blank');
			win.focus();
		},

		clean_user() {
			this.users = [];
		},

		close_modal() {
			this.close();
		},

		close() {
			this.users = [];
			this.is_show_modal = false;
		},

		async load_users(users) {
			this.is_load = true;
			console.log('selected_user',users);
			let ids = [];
			this.users = [];
			users.map(user => {
				ids.push(user.id);
			})

			await api.post('/equipment/by/users',{'ids' : ids}).then(({data}) => {
				this.is_load = false;
				this.users = data.data.map(item => {
					if(item.hasOwnProperty('equipments')) {
						item.equipments.map(equip => {
							equip.is_selected = true;
						});
					}
					return item;
				});
				this.is_show_modal = true;
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
				this.is_load = false;
			})
				.finally(() => {
					IMC_CORE.hideloading();
					this.is_load = false;
				});
		},
	},

	computed : {
		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-xl";
			}

			return "modal-dialog-right modal-xl";
		},
	}
}
</script>



<style scoped>

</style>